<template>
  <div class="chat">
    <headd :mobile_title="recipient_id"></headd>
    <div class="uni-column">
      <div class="msg_head ">{{ recipient_id }}</div>
      <div class="content_2" ref="content_list" id="content_list">
        <div class="content_1">
          <div v-if="historyshow" @click="gomorehistory" class="history">
            加载更多历史
          </div>
          <div class="con" v-for="(message, index) in messages" :key="index">
            <div class="m-item" :id="'message' + index">
              <div
                class="time"
                v-if="
                  index > 0 &&
                    messages[index - 1].createdAt != message.createdAt &&
                    message.createdAt
                "
              >
                {{ message.createdAt }}
              </div>
              <div class="time" v-else-if="index === 0">
                {{ message.createdAt }}
              </div>
              <div class="m-left">
                <img
                  class="head_icon"
                  :src="
                    message.avatarUrl != ''
                      ? message.avatarUrl
                      : '../../../static/user/icon_1.png'
                  "
                  v-if="message.msgtype == 'receive'"
                />
              </div>
              <div class="m-content">
                <div
                  class="m-content-head"
                  :class="{ 'm-content-head-right': message.msgtype == 'send' }"
                >
                  <div
                    v-if="message.content != ''"
                    :class="'m-content-head-' + message.msgtype"
                  >
                    {{ message.content }}
                  </div>
                  <div
                    class="file"
                    v-else-if="message.fileUrlJson != null"
                    :class="'m-content-head-' + message.msgtype"
                  >
                    <a :href="message.fileUrlJson | filepath">{{
                      message.fileUrlJson | file
                    }}</a>
                    <img src="../../../static/order/icon_2.png" />
                  </div>
                  <div
                    class="img"
                    v-else-if="message.imgUrlJson != ''"
                    :class="'m-content-head-' + message.msgtype"
                  >
                    <el-image
                      class="my-img"
                      mode="widthFix"
                      v-if="message.imgUrlJson.indexOf('http') == 0"
                      :src="message.imgUrlJson"
                      :preview-src-list="getimgArr()"
                    >
                    </el-image>

                    <el-image
                      v-else
                      class="my-img"
                      mode="widthFix"
                      :src="www + message.imgUrlJson"
                      :preview-src-list="getimgArr()"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
              <div class="m-right">
                <img
                  class="head_icon"
                  :src="
                    message.avatarUrl != ''
                      ? message.avatarUrl
                      : '../../../static/user/icon_1.png'
                  "
                  v-if="message.msgtype == 'send'"
                />
              </div>
            </div>
          </div>
          <div
            v-for="(message, index) in messages_new"
            :key="'info2-' + index"
            v-if="messages_new"
          >

            <div class="m-item" :id="'messages_new' + index">
              <div
                class="time"
                v-if="
                  index > 0 &&
                    messages_new[index - 1].createdAt != message.createdAt &&
                    message.createdAt
                "
              >
                {{ message.createdAt }}
              </div>
              <div class="m-left">
                <img
                  class="head_icon"
                  :src="
                    message.avatarUrl != ''
                      ? message.avatarUrl
                      : '../../../static/user/icon_1.png'
                  "
                  v-if="message.msgtype == 'receive'"
                />
              </div>
              <div class="m-content">
                <div
                  class="m-content-head"
                  :class="{ 'm-content-head-right': message.msgtype == 'send' }"
                >
                  <div
                    v-if="message.content != ''"
                    :class="'m-content-head-' + message.msgtype"
                  >
                    {{ message.content }}
                  </div>
                  <div
                    class="file"
                    v-else-if="message.fileUrlJson != null"
                    :class="'m-content-head-' + message.msgtype"
                  >
                    <a :href="message.fileUrlJson | filepath">{{
                      message.fileUrlJson | file
                    }}</a>
                    <img src="../../../static/order/icon_2.png" />
                  </div>

                  <div
                    class="img"
                    v-else-if="message.imgUrlJson != ''"
                    :class="'m-content-head-' + message.msgtype"
                  >
                    <el-image
                      class="my-img"
                      mode="widthFix"
                      v-if="message.imgUrlJson.indexOf('http') == 0"
                      :src="message.imgUrlJson"
                      :preview-src-list="getimgArr()"
                    >
                    </el-image>

                    <el-image
                      v-else
                      class="my-img"
                      mode="widthFix"
                      :src="www + message.imgUrlJson"
                      :preview-src-list="getimgArr()"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
              <div class="m-right">
                <img
                  class="head_icon"
                  :src="
                    message.avatarUrl != ''
                      ? message.avatarUrl
                      : '../../../static/user/icon_1.png'
                  "
                  v-if="message.msgtype == 'send'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="foot">
        <chatinput
          :www="www"
          :apiurl="apiurl"
          @send-message="getInputMessage"
        ></chatinput>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import { gethistoryMsg, getsendDialogmsg, getlastMsg } from "../api/api"; //引入api里面定义的方法

import chatinput from "@/components/chatinput";
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "",
      www: this.common.www_img,
      apiurl: this.common.apiurl,
      style: {
        pageHeight: 0,
        contentViewHeight: 0,
        footViewHeight: 90,
        mitemHeight: 0
      },
      scrollTop: 0,
      messages: [],
      messages_new: [],
      lastid: 0,
      lastid_new: 0,
      msgtimer: null,
      refreshType: "custom",
      refreshTip: "正在下拉",
      loadTip: "获取更多数据",
      loadingTip: "正在加载中...",
      emptyTip: "--我是有底线的--",
      touchHeight: 50,
      height: 0,
      bottom: 50,
      autoPullUp: false,
      stopPullDown: true, // 如果为 false 则不使用下拉刷新，只进行上拉加载
      //www: getApp().globalData.www,
      id_i: 1000,
      limit: 20,
      index: 1,
      first: true,
      recipient_id: 0,
      history: true,
      historyshow: false
    };
  },

  mounted() {
    //console.log(123);
    this.gethistoryMsgList();
    this.timedemo();
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    chatinput,
    headd,
    foot
  },
  methods: {
  getimgArr(){
        var _self = this
        let dataArray = [];
        let imgsArray = [];
        dataArray=_self.messages.concat(_self.messages_new)
        console.log(dataArray);
        for(let i in dataArray){
            if(dataArray[i].imgUrlJson !=''){
            if(dataArray[i].imgUrlJson.indexOf('http') == 0){
              imgsArray.push(dataArray[i].imgUrlJson)
            }else{
              imgsArray.push(_self.www+dataArray[i].imgUrlJson)
            }
          }
        }
        console.log(imgsArray);
        

        
        return imgsArray;
    },
    _previewImage(image) {
      var imgArr = [];
      imgArr.push(image);
      //预览图片
      uni.previewImage({
        urls: imgArr,
        current: imgArr[0]
      });
    },
    getInputMessage(message) {
      //获取子组件的输入数据
      //console.log(message);
      this.addMessage("customer", message.content, message.type, false);
      this.toRobot(message);
      this.id_i++;
    },
    addMessage: function(user, content, type, hasSub) {
      var that = this;
      //console.log(content,uni.getStorageSync('userinfo').avatarUrl)
      if (type == "img") {
        that.messages_new.push({
          id: that.id_i,
          avatarUrl: localStorage.getItem("avatarUrl"),
          content: "",
          imgUrlJson: content,
          type: type,
          msgtype: "send",
          createdAt: ""
        });
      } else if (type == "file") {
        that.messages_new.push({
          id: that.id_i,
          avatarUrl: localStorage.getItem("avatarUrl"),
          content: "",
          fileUrlJson: JSON.stringify(content),
          type: type,
          msgtype: "send",
          createdAt: ""
        });
      } else {
        that.messages_new.push({
          id: that.id_i,
          avatarUrl: localStorage.getItem("avatarUrl"),
          content: content,
          imgUrlJson: "",
          type: type,
          msgtype: "send",
          createdAt: ""
        });
      }

      this.$nextTick(() => {
        $("#content_list").scrollTop(999999);
      });
    },

    async toRobot(info) {
      var _self = this;
      //console.log(info)
      var parm = {};
      var query = this.$route.query;
      if (info.type == "text") {
        parm = {
          uid: query.uid,
          recipient_id: query.recipient_id,
          sendmsg: info.content
        };
      } else if (info.type == "file") {
        parm = {
          uid: query.uid,
          recipient_id: query.recipient_id,
          fileUrlJson: JSON.stringify(info.content)
        };
      } else {
        parm = {
          uid: query.uid,
          recipient_id: query.recipient_id,
          imgUrlJson: info.content
        };
      }
      console.log(parm);
      const res = await getsendDialogmsg(parm);
      $("#content_list").scrollTop(999999);
      //console.log(res);
    },
    async gethistoryMsgList() {
      //console.log(123);
      var _slef = this;
      var parm = this.$route.query;
      var parms = {
        uid: parm.uid,
        recipient_id: parm.recipient_id,
        lastid: _slef.lastid,
        limit: _slef.limit
        // page: _slef.pageindex,
        // limit: 5,
      };

      const res = await gethistoryMsg(parms);

      const messages = _slef.messages.concat(res.data.data.historymsg);
      const data = res.data.data.historymsg;

      messages.sort(function(a, b) {
        return a.id - b.id;
      });
      _slef.messages = messages;
      if (res.data.data.historymsg.length > 0) {
        //console.log(res.data.data.historymsg[3].id)
        _slef.lastid =
          res.data.data.historymsg[res.data.data.historymsg.length - 1].id;
        this.historyshow = true;
      } else {
        this.historyshow = false;
      }
      if (_slef.first) {
        if (_slef.messages.length > 0) {
          _slef.lastid_new = _slef.messages[_slef.messages.length - 1].id;
        }
        _slef.first = false;
      }

      //console.log(_slef.lastid, _slef.lastid_new);
      _slef.recipient_id = res.data.data.dialogTitle;
      const sel = `#message${
        _slef.index > 1 ? this.messages.length : data.length - 1
      }`;
      //console.log(sel)
      this.$nextTick(() => {
        this.bindScroll(sel);
        //如果还有数据
        if (this.limit >= data.length) {
          this.index++;
        }
      });
    },

    //处理滚动
    bindScroll(sel, duration = 0) {
      var h = $("#content_list").innerHeight();
      //   $("#content_list .con").each(function() {
      //     console.log(this.innerHeight());
      //   });
      if (this.history) {
        $("#content_list").scrollTop(999999999);
      }

      //   var timer = setTimeout(() => {
      //     this.$refs.content_list.scrollTo(99999, 0);
      //     clearTimeout(timer);
      //   }, 50);
    },
    async getlastMsg() {
      var _slef = this;
      var parm = this.$route.query;
      var data = {
        uid: parm.uid,
        recipient_id: parm.recipient_id,
        lastid: _slef.lastid_new,
        limit: 5
      };
      const res = await getlastMsg(data);
      //console.log(res)

      console.log(res.data.data.newmsg.length);
      if (res.data.data.newmsg.length > 0) {
        _slef.messages_new = _slef.messages_new.concat(res.data.data.newmsg);
        _slef.lastid_new =
          res.data.data.newmsg[res.data.data.newmsg.length - 1].id;
        this.$nextTick(() => {
          this.$refs.content_list.scrollTo(
            0,
            99999999 //小程序如果有滚动效果 input的焦点也会随着页面滚动...
          );
        });
      }
    },
    handlePullDown(stopLoad) {
      this.gethistoryMsg();
      stopLoad ? stopLoad() : "";
    },
    gomorehistory() {
      this.history = false;
      this.gethistoryMsgList();
    },

    timedemo() {
      this.msgtimer = setInterval(() => {
        this.getlastMsg();
      }, 1500);
    },
    clearTimer() {
      clearInterval(this.msgtimer);
      this.msgtimer = null;
    }
  },

  destroyed() {
    this.msgtimer && this.clearTimer();
  }
};
</script>
<style scoped lang="less">
body {
  background-color: #000 !important;
}
.chat {
  @media (max-width: 991px) {
    width: 100%;
    margin: auto;
    .container {
      padding: 0;
    }
  }
}
.scroll-content {
  flex-wrap: wrap;
}

.uni-column {
  width: 7.5rem;
  height: 7rem;
  overflow: hidden;
  margin: 0.3rem auto;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f2f2f2;
  @media (max-width: 991px) {
    width: 100%;
    height: ~"calc(100vh - 1.2rem)";
    margin: 0rem auto;
  }
}

.scroll-content {
  flex-direction: column;
}

.content_2 {
  display: flex;
  padding-bottom: 1.2rem;
  background-color: #f2f2f2;
  height: 5rem;
  overflow-x: hidden;
  @media (max-width: 991px) {
    width: 100%;
    height: ~"calc(100vh - 3.1rem)";
  }
}
.content_1 {
  height: auto;
  flex-flow: row wrap;
  align-items: flex-start;
  @media (max-width: 991px) {
    width: 100%;
  }
}

.foot {
  position: absolute;

  width: 100%;
  height: auto;
  /* min-height: 90rpx; */
  left: 0px;
  bottom: 0rem;
  overflow: hidden;
}

.m-item {
  display: flex;
  flex-direction: row;
  padding-top: 0.4rem;
  width: 7.5rem;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    width: 100%;
  }
}

.m-left {
  display: flex;
  width: 0.6rem;
  justify-content: center;
  align-items: flex-start;
  margin-right: 0.1rem;
  margin-left: 0.2rem;
  @media (max-width: 991px) {
    width: 0.8rem;
  }
}

.m-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  word-break: break-all;
  margin-top: 0.1rem;
}

.time {
  font-size: 0.14rem;
  text-align: center;
  margin: 0.2rem 0;
  width: 7.5rem;

  justify-content: center;
  color: #999;
}

.m-right {
  display: flex;
  width: 0.6rem;
  justify-content: center;
  align-items: flex-start;
  margin-left: 0.1rem;
  margin-right: 0.2rem;
  @media (max-width: 991px) {
    width: 0.8rem;
  }
}

.head_icon {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  overflow: hidden;
  @media (max-width: 991px) {
    width: 0.8rem;
    height: 0.8rem;
  }
}

.m-content-head {
  position: relative;
  display: inline-flex;
}

.m-content-head-right {
  display: flex;
  justify-content: flex-end;
}

.m-content-head-receive {
  text-align: left;
  background: #fff;
  border: 0.01rem #fff solid;
  border-radius: 0.1rem;
  padding: 0.1rem;
  color: #333;
  font-size: 0.16rem;
  @media (max-width: 991px) {
    font-size: 0.3rem;
  }
}

.m-content-head-receive:before {
  border: 0.1rem solid transparent;
  border-right: 0.1rem solid #fff;
  left: -0.16rem;
  width: 0;
  height: 0;
  position: absolute;
  content: " ";
}

.m-content-head-receive .el-image {
  width: 100%;
  /deep/.el-image__inner {
    width: 1.5rem;
    /* height: 1rem; */
  }
}

.m-content-head-receive .my-img img {
  width: 1rem;
  /* height: 1rem; */
}

.img {
  background: none;
  border: none;
  border-radius: 0rem;
  padding: 0 0.1rem;
}
.img:before {
  border: none;
}

.m-content-head-send {
  border: 0.01rem #9eea6a solid;
  background: #9eea6a;
  border-radius: 0.1rem;
  padding: 0.1rem;
  color: #000;
  font-size: 0.16rem;
  text-align: left;
  @media (max-width: 991px) {
    font-size: 0.3rem;
  }
}

.m-content-head-send:after {
  border: 0.1rem solid transparent;
  border-left: 0.1rem solid #9eea6a;
  top: 0.12rem;
  right: -0.18rem;
  width: 0;
  height: 0;
  position: absolute;
  content: " ";
}

.m-content-head-send .el-image {
  width: 100%;
  /deep/.el-image__inner {
    width: 1.5rem;
    /* height: 1rem; */
  }
}
.img {
  background: none;
  border: none;
  border-radius: 0rem;
  padding: 0 0.1rem;
}
.img:after {
  border: none;
}
.file {
  background: #fff;
  border: 0.01rem #fff solid;
  border-radius: 0.1rem;
  padding: 0.2rem;
  display: flex;
}
.file:after {
  border: none;
}
.file a {
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-decoration: none;
}
.file img {
  margin: 0.05rem;
  width: 0.3rem;
  height: 0.264rem;
  @media (max-width: 991px) {
    margin: 0.1rem;
    width: 0.6rem;
    height: 0.528rem;
  }
}
.msg_head {
  width: 100%;
  height: 0.8rem;
  font-size: 0.2rem;
  background: #f9f9f9;
  line-height: 0.8rem;
  @media (max-width: 991px) {
    font-size: 0.3rem;
  }
}
.el-image__inner {
  width: 1.5rem !important;
}
.history {
  font-size: 0.16rem;
  margin: 0.15rem 0;
  @media (max-width: 991px) {
    font-size: 0.26rem;
  }
}
@media (max-width: 991px) {
  .head_line {
    border-bottom: 0rem solid #ccc;
    padding-bottom: 0rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/message/chat.vue